import React from 'react'

import { Item, Count, TitleBackground, Title, ImageBackground, Image } from '../../MenuOption'

import daily from '../../../assets/img/daily.png'
import weekly from '../../../assets/img/weekly.png'
import themed from '../../../assets/img/themed.png'
import pro from '../../../assets/img/pro.png'
import quick from '../../../assets/img/quick.png'

const images = { daily, weekly, themed, pro, quick }

function ChallengeCategory (props){
  return (
    <Item selected={ props.selected } onClick={ props.event }>
      <TitleBackground selected={ props.selected }/>
      <Title selected={ props.selected }>{ props.text }</Title>
      <ImageBackground selected={ props.selected }/>
      <Image selected={ props.selected }><img src={ images[props.type] }/></Image>
      <Count selected={ props.selected }> { `${props.current}/${props.total}`}</Count>
    </Item>
  )
}

export default ChallengeCategory